import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-700 font-light bg-gray-100" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "md:flex mb-2" }
const _hoisted_4 = { class: "pb-1" }
const _hoisted_5 = { class: "md:border-r border-gray-300 pl-2 pr-2 hover:text-gray-500" }
const _hoisted_6 = { class: "pb-1" }
const _hoisted_7 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("実践トレードラボご利用規約")
const _hoisted_9 = { class: "pb-1" }
const _hoisted_10 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("神藤塾ご利用規約")
const _hoisted_12 = {
  key: 1,
  class: "pb-1"
}
const _hoisted_13 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("神藤塾ご利用規約")
const _hoisted_15 = {
  key: 2,
  class: "pb-1"
}
const _hoisted_16 = { class: "md:border-r border-gray-300 px-2 hover:text-gray-500" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("神藤塾ご利用規約")
const _hoisted_18 = { class: "pl-2 hover:text-gray-500" }
const _hoisted_19 = { class: "pl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_layouts_auth_width, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/contact" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('contact.title')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.isLabo)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("li", _hoisted_7, [
                      _createVNode(_component_router_link, { to: "/terms-labo" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("li", _hoisted_10, [
                      _createVNode(_component_router_link, { to: "/terms-shindo" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ], 64))
              : (_ctx.isShindo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("li", _hoisted_13, [
                      _createVNode(_component_router_link, { to: "/terms-shindo" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _createVNode(_component_router_link, { to: "/terms-shindo" }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ])
                  ])),
            _createElementVNode("div", null, [
              _createElementVNode("li", _hoisted_18, [
                _createVNode(_component_router_link, { to: "/account" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('word.setting')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, " © " + _toDisplayString(new Date().getFullYear()) + " 手塚宏二事務所 ", 1)
        ])
      ]),
      _: 1
    })
  ]))
}